// Multilingual support with transliteration for Indian languages
// Using transliteration (phonetic representation) instead of full translation

export const LANGUAGES = {
  en: { code: 'en', name: 'English', nativeName: 'English' },
  hi: { code: 'hi', name: 'Hindi', nativeName: 'हिन्दी' },
  te: { code: 'te', name: 'Telugu', nativeName: 'తెలుగు' },
  mr: { code: 'mr', name: 'Marathi', nativeName: 'मराठी' },
  kn: { code: 'kn', name: 'Kannada', nativeName: 'ಕನ್ನಡ' },
  ta: { code: 'ta', name: 'Tamil', nativeName: 'தமிழ்' },
  bn: { code: 'bn', name: 'Bengali', nativeName: 'বাংলা' },
  gu: { code: 'gu', name: 'Gujarati', nativeName: 'ગુજરાતી' },
};

// Transliterations for common UI text
export const translations = {
  // Navigation & Common
  home: {
    en: 'Home',
    hi: 'होम',
    te: 'హోమ్',
    mr: 'होम',
    kn: 'ಹೋಮ್',
    ta: 'ஹோம்',
    bn: 'হোম',
    gu: 'હોમ',
  },
  book_ride: {
    en: 'Book Ride',
    hi: 'राइड बुक करें',
    te: 'రైడ్ బుక్ చేయండి',
    mr: 'राइड बुक करा',
    kn: 'ರೈಡ್ ಬುಕ್ ಮಾಡಿ',
    ta: 'ரைடு புக் செய்யுங்கள்',
    bn: 'রাইড বুক করুন',
    gu: 'રાઇડ બુક કરો',
  },
  history: {
    en: 'History',
    hi: 'हिस्ट्री',
    te: 'హిస్టరీ',
    mr: 'हिस्ट्री',
    kn: 'ಹಿಸ್ಟರಿ',
    ta: 'ஹிஸ்டரி',
    bn: 'হিস্ট্রি',
    gu: 'હિસ્ટ્રી',
  },
  profile: {
    en: 'Profile',
    hi: 'प्रोफाइल',
    te: 'ప్రొఫైల్',
    mr: 'प्रोफाइल',
    kn: 'ಪ್ರೊಫೈಲ್',
    ta: 'ப்ரொஃபைல்',
    bn: 'প্রোফাইল',
    gu: 'પ્રોફાઇલ',
  },
  package: {
    en: 'Package',
    hi: 'पैकेज',
    te: 'ప్యాకేజ్',
    mr: 'पॅकेज',
    kn: 'ಪ್ಯಾಕೇಜ್',
    ta: 'பேக்கேஜ்',
    bn: 'প্যাকেজ',
    gu: 'પેકેજ',
  },
  settings: {
    en: 'Settings',
    hi: 'सेटिंग्स',
    te: 'సెట్టింగ్స్',
    mr: 'सेटिंग्स',
    kn: 'ಸೆಟ್ಟಿಂಗ್ಸ್',
    ta: 'செட்டிங்ஸ்',
    bn: 'সেটিংস',
    gu: 'સેટિંગ્સ',
  },

  // Booking Types
  booking_type: {
    en: 'Booking Type',
    hi: 'बुकिंग टाइप',
    te: 'బుకింగ్ టైప్',
    mr: 'बुकिंग टाइप',
    kn: 'ಬುಕಿಂಗ್ ಟೈಪ್',
    ta: 'புக்கிங் டைப்',
    bn: 'বুকিং টাইপ',
    gu: 'બુકિંગ ટાઇપ',
  },
  one_way: {
    en: 'One Way',
    hi: 'वन वे',
    te: 'వన్ వే',
    mr: 'वन वे',
    kn: 'ಒನ್ ವೇ',
    ta: 'ஒன் வே',
    bn: 'ওয়ান ওয়ে',
    gu: 'વન વે',
  },
  round_trip: {
    en: 'Round Trip',
    hi: 'राउंड ट्रिप',
    te: 'రౌండ్ ట్రిప్',
    mr: 'राउंड ट्रिप',
    kn: 'ರೌಂಡ್ ಟ್ರಿಪ್',
    ta: 'ரவுண்ட் ட்ரிப்',
    bn: 'রাউন্ড ট্রিপ',
    gu: 'રાઉન્ડ ટ્રિપ',
  },
  hourly: {
    en: 'Hourly',
    hi: 'घंटे के हिसाब से',
    te: 'గంటల వారీగా',
    mr: 'तासाने',
    kn: 'ಗಂಟೆಗೆ',
    ta: 'மணிநேரம்',
    bn: 'ঘণ্টায়',
    gu: 'કલાક દીઠ',
  },
  daily: {
    en: 'Daily',
    hi: 'दिन के हिसाब से',
    te: 'రోజువారీ',
    mr: 'दररोज',
    kn: 'ದಿನಕ್ಕೆ',
    ta: 'தினசரி',
    bn: 'দৈনিক',
    gu: 'દૈનિક',
  },
  package_delivery: {
    en: 'Package',
    hi: 'पैकेज',
    te: 'ప్యాకేజ్',
    mr: 'पॅकेज',
    kn: 'ಪ್ಯಾಕೇಜ್',
    ta: 'பேக்கேஜ்',
    bn: 'প্যাকেজ',
    gu: 'પેકેજ',
  },

  // Booking Type Descriptions (transliterated)
  point_a_to_b: {
    en: 'Point A to B',
    hi: 'पॉइंट A से B',
    te: 'పాయింట్ A నుండి B',
    mr: 'पॉइंट A ते B',
    kn: 'ಪಾಯಿಂಟ್ A ನಿಂದ B',
    ta: 'பாயிண்ட் A இல் இருந்து B',
    bn: 'পয়েন্ট A থেকে B',
    gu: 'પોઇન્ટ A થી B',
  },
  a_to_b_back: {
    en: 'A to B & back',
    hi: 'A से B और वापस',
    te: 'A నుండి B మరియు తిరిగి',
    mr: 'A ते B आणि परत',
    kn: 'A ನಿಂದ B ಮತ್ತು ಹಿಂದೆ',
    ta: 'A இல் இருந்து B மற்றும் திரும்ப',
    bn: 'A থেকে B এবং ফিরে',
    gu: 'A થી B અને પાછા',
  },
  pay_per_hour: {
    en: 'Pay per hour',
    hi: 'प्रति घंटा भुगतान',
    te: 'గంటకు చెల్లించండి',
    mr: 'प्रति तास पेमेंट',
    kn: 'ಗಂಟೆಗೆ ಪಾವತಿ',
    ta: 'மணிக்கு பேமென்ட்',
    bn: 'প্রতি ঘণ্টা পেমেন্ট',
    gu: 'કલાક દીઠ પેમેન્ટ',
  },
  full_day_rental: {
    en: 'Full day rental',
    hi: 'पूरे दिन का रेंटल',
    te: 'పూర్తి రోజు రెంటల్',
    mr: 'पूर्ण दिवस रेंटल',
    kn: 'ಪೂರ್ಣ ದಿನ ಬಾಡಿಗೆ',
    ta: 'முழு நாள் ரெண்டல்',
    bn: 'পুরো দিনের রেন্টাল',
    gu: 'આખા દિવસનું રેન્ટલ',
  },
  send_parcel: {
    en: 'Send a parcel',
    hi: 'पार्सल भेजें',
    te: 'పార్సెల్ పంపండి',
    mr: 'पार्सल पाठवा',
    kn: 'ಪಾರ್ಸೆಲ್ ಕಳುಹಿಸಿ',
    ta: 'பார்சல் அனுப்புங்கள்',
    bn: 'পার্সেল পাঠান',
    gu: 'પાર્સલ મોકલો',
  },

  // Location
  pickup_location: {
    en: 'Pickup Location',
    hi: 'पिकअप लोकेशन',
    te: 'పికప్ లొకేషన్',
    mr: 'पिकअप लोकेशन',
    kn: 'ಪಿಕಪ್ ಲೊಕೇಶನ್',
    ta: 'பிக்கப் லொகேஷன்',
    bn: 'পিকআপ লোকেশন',
    gu: 'પિકઅપ લોકેશન',
  },
  drop_location: {
    en: 'Drop Location',
    hi: 'ड्रॉप लोकेशन',
    te: 'డ్రాప్ లొకేషన్',
    mr: 'ड्रॉप लोकेशन',
    kn: 'ಡ್ರಾಪ್ ಲೊಕೇಶನ್',
    ta: 'டிராப் லொகேஷன்',
    bn: 'ড্রপ লোকেশন',
    gu: 'ડ્રોપ લોકેશન',
  },
  drop_optional: {
    en: 'Drop location is optional for this booking type',
    hi: 'इस बुकिंग टाइप के लिए ड्रॉप लोकेशन ऑप्शनल है',
    te: 'ఈ బుకింగ్ టైప్ కోసం డ్రాప్ లొకేషన్ ఆప్షనల్',
    mr: 'या बुकिंग टाइपसाठी ड्रॉप लोकेशन ऑप्शनल आहे',
    kn: 'ಈ ಬುಕಿಂಗ್ ಟೈಪ್‌ಗೆ ಡ್ರಾಪ್ ಲೊಕೇಶನ್ ಆಪ್ಶನಲ್',
    ta: 'இந்த புக்கிங் டைப்புக்கு டிராப் லொகேஷன் ஆப்ஷனல்',
    bn: 'এই বুকিং টাইপের জন্য ড্রপ লোকেশন অপশনাল',
    gu: 'આ બુકિંગ ટાઇપ માટે ડ્રોપ લોકેશન ઓપ્શનલ છે',
  },
  where_to_go: {
    en: 'Where do you want to go?',
    hi: 'आप कहाँ जाना चाहते हैं?',
    te: 'మీరు ఎక్కడికి వెళ్ళాలనుకుంటున్నారు?',
    mr: 'तुम्हाला कुठे जायचे आहे?',
    kn: 'ನೀವು ಎಲ್ಲಿಗೆ ಹೋಗಬೇಕು?',
    ta: 'நீங்கள் எங்கே செல்ல விரும்புகிறீர்கள்?',
    bn: 'আপনি কোথায় যেতে চান?',
    gu: 'તમે ક્યાં જવા માંગો છો?',
  },
  current_location: {
    en: 'Current Location',
    hi: 'वर्तमान लोकेशन',
    te: 'ప్రస్తుత లొకేషన్',
    mr: 'सध्याचे लोकेशन',
    kn: 'ಪ್ರಸ್ತುತ ಲೊಕೇಶನ್',
    ta: 'தற்போதைய லொகேஷன்',
    bn: 'বর্তমান লোকেশন',
    gu: 'વર્તમાન લોકેશન',
  },

  // Vehicle Types
  select_vehicle: {
    en: 'Select Vehicle',
    hi: 'वाहन चुनें',
    te: 'వాహనాన్ని ఎంచుకోండి',
    mr: 'वाहन निवडा',
    kn: 'ವಾಹನ ಆಯ್ಕೆಮಾಡಿ',
    ta: 'வாகனத்தைத் தேர்ந்தெடுக்கவும்',
    bn: 'গাড়ি নির্বাচন করুন',
    gu: 'વાહન પસંદ કરો',
  },
  bike: {
    en: 'Bike',
    hi: 'बाइक',
    te: 'బైక్',
    mr: 'बाइक',
    kn: 'ಬೈಕ್',
    ta: 'பைக்',
    bn: 'বাইক',
    gu: 'બાઇક',
  },
  auto: {
    en: 'Auto',
    hi: 'ऑटो',
    te: 'ఆటో',
    mr: 'ऑटो',
    kn: 'ಆಟೋ',
    ta: 'ஆட்டோ',
    bn: 'অটো',
    gu: 'ઓટો',
  },
  car: {
    en: 'Car',
    hi: 'कार',
    te: 'కార్',
    mr: 'कार',
    kn: 'ಕಾರ್',
    ta: 'கார்',
    bn: 'কার',
    gu: 'કાર',
  },

  // Vehicle Descriptions
  quick_cheap: {
    en: 'Quick & cheap',
    hi: 'तेज़ और सस्ता',
    te: 'వేగవంతమైన & చౌక',
    mr: 'जलद आणि स्वस्त',
    kn: 'ವೇಗ ಮತ್ತು ಅಗ್ಗ',
    ta: 'வேகமான & மலிவான',
    bn: 'দ্রুত ও সস্তা',
    gu: 'ઝડપી અને સસ્તું',
  },
  comfortable: {
    en: 'Comfortable',
    hi: 'आरामदायक',
    te: 'సౌకర్యవంతమైన',
    mr: 'आरामदायी',
    kn: 'ಆರಾಮದಾಯಕ',
    ta: 'வசதியான',
    bn: 'আরামদায়ক',
    gu: 'આરામદાયક',
  },
  premium: {
    en: 'Premium',
    hi: 'प्रीमियम',
    te: 'ప్రీమియం',
    mr: 'प्रीमियम',
    kn: 'ಪ್ರೀಮಿಯಂ',
    ta: 'பிரீமியம்',
    bn: 'প্রিমিয়াম',
    gu: 'પ્રીમિયમ',
  },
  nearby: {
    en: 'nearby',
    hi: 'पास में',
    te: 'సమీపంలో',
    mr: 'जवळ',
    kn: 'ಹತ್ತಿರ',
    ta: 'அருகில்',
    bn: 'কাছাকাছি',
    gu: 'નજીકમાં',
  },
  unavailable: {
    en: 'Unavailable',
    hi: 'उपलब्ध नहीं',
    te: 'అందుబాటులో లేదు',
    mr: 'उपलब्ध नाही',
    kn: 'ಲಭ್ಯವಿಲ್ಲ',
    ta: 'கிடைக்கவில்லை',
    bn: 'উপলব্ধ নেই',
    gu: 'ઉપલબ્ધ નથી',
  },

  // Actions
  get_fare_estimate: {
    en: 'Get Fare Estimate',
    hi: 'किराया पता करें',
    te: 'ఫేర్ ఎస్టిమేట్ చూడండి',
    mr: 'भाडे अंदाज पहा',
    kn: 'ದರ ಅಂದಾಜು ಪಡೆಯಿರಿ',
    ta: 'கட்டண மதிப்பீடு பெறுங்கள்',
    bn: 'ভাড়ার অনুমান দেখুন',
    gu: 'ભાડાનો અંદાજ મેળવો',
  },
  book_now: {
    en: 'Book Now',
    hi: 'अभी बुक करें',
    te: 'ఇప్పుడే బుక్ చేయండి',
    mr: 'आता बुक करा',
    kn: 'ಈಗ ಬುಕ್ ಮಾಡಿ',
    ta: 'இப்போதே புக் செய்யுங்கள்',
    bn: 'এখনই বুক করুন',
    gu: 'હમણાં બુક કરો',
  },
  confirm_booking: {
    en: 'Confirm Booking',
    hi: 'बुकिंग कन्फर्म करें',
    te: 'బుకింగ్ కన్ఫర్మ్ చేయండి',
    mr: 'बुकिंग कन्फर्म करा',
    kn: 'ಬುಕಿಂಗ್ ಕನ್ಫರ್ಮ್ ಮಾಡಿ',
    ta: 'புக்கிங் கன்ஃபர்ம் செய்யுங்கள்',
    bn: 'বুকিং কনফার্ম করুন',
    gu: 'બુકિંગ કન્ફર્મ કરો',
  },
  cancel: {
    en: 'Cancel',
    hi: 'कैंसल',
    te: 'క్యాన్సల్',
    mr: 'कॅन्सल',
    kn: 'ಕ್ಯಾನ್ಸಲ್',
    ta: 'கேன்சல்',
    bn: 'ক্যান্সেল',
    gu: 'કેન્સલ',
  },
  logout: {
    en: 'Logout',
    hi: 'लॉगआउट',
    te: 'లాగౌట్',
    mr: 'लॉगआउट',
    kn: 'ಲಾಗೌಟ್',
    ta: 'லாகவுட்',
    bn: 'লগআউট',
    gu: 'લોગઆઉટ',
  },
  select_pickup: {
    en: 'Select Pickup Location',
    hi: 'पिकअप लोकेशन चुनें',
    te: 'పికప్ లొకేషన్ ఎంచుకోండి',
    mr: 'पिकअप लोकेशन निवडा',
    kn: 'ಪಿಕಪ್ ಲೊಕೇಶನ್ ಆಯ್ಕೆಮಾಡಿ',
    ta: 'பிக்கப் லொகேஷன் தேர்ந்தெடுக்கவும்',
    bn: 'পিকআপ লোকেশন নির্বাচন করুন',
    gu: 'પિકઅપ લોકેશન પસંદ કરો',
  },
  select_drop: {
    en: 'Select Drop Location',
    hi: 'ड्रॉप लोकेशन चुनें',
    te: 'డ్రాప్ లొకేషన్ ఎంచుకోండి',
    mr: 'ड्रॉप लोकेशन निवडा',
    kn: 'ಡ್ರಾಪ್ ಲೊಕೇಶನ್ ಆಯ್ಕೆಮಾಡಿ',
    ta: 'டிராப் லொகேஷன் தேர்ந்தெடுக்கவும்',
    bn: 'ড্রপ লোকেশন নির্বাচন করুন',
    gu: 'ડ્રોપ લોકેશન પસંદ કરો',
  },
  confirm_your_ride: {
    en: 'Confirm Your Ride',
    hi: 'अपनी राइड कन्फर्म करें',
    te: 'మీ రైడ్ కన్ఫర్మ్ చేయండి',
    mr: 'तुमची राइड कन्फर्म करा',
    kn: 'ನಿಮ್ಮ ರೈಡ್ ಕನ್ಫರ್ಮ್ ಮಾಡಿ',
    ta: 'உங்கள் ரைடை கன்ஃபர்ம் செய்யுங்கள்',
    bn: 'আপনার রাইড কনফার্ম করুন',
    gu: 'તમારી રાઇડ કન્ફર્મ કરો',
  },
  drop_to_be_decided: {
    en: 'Drop-off to be decided (Rental)',
    hi: 'ड्रॉप बाद में तय होगा (रेंटल)',
    te: 'డ్రాప్-ఆఫ్ తర్వాత తేల్చబడుతుంది (రెంటల్)',
    mr: 'ड्रॉप नंतर ठरवले जाईल (रेंटल)',
    kn: 'ಡ್ರಾಪ್-ಆಫ್ ನಂತರ ನಿರ್ಧರಿಸಲಾಗುವುದು (ಬಾಡಿಗೆ)',
    ta: 'டிராப்-ஆஃப் பின்னர் தீர்மானிக்கப்படும் (ரெண்டல்)',
    bn: 'ড্রপ-অফ পরে ঠিক হবে (রেন্টাল)',
    gu: 'ડ્રોપ-ઓફ પછી નક્કી થશે (રેન્ટલ)',
  },
  surge_pricing: {
    en: 'Surge pricing active',
    hi: 'सर्ज प्राइसिंग एक्टिव',
    te: 'సర్జ్ ప్రైసింగ్ యాక్టివ్',
    mr: 'सर्ज प्राइसिंग ॲक्टिव्ह',
    kn: 'ಸರ್ಜ್ ಪ್ರೈಸಿಂಗ್ ಆಕ್ಟಿವ್',
    ta: 'சர்ஜ் ப்ரைசிங் ஆக்டிவ்',
    bn: 'সার্জ প্রাইসিং অ্যাক্টিভ',
    gu: 'સર્જ પ્રાઇસિંગ એક્ટિવ',
  },

  // Fare & Payment
  fare_estimate: {
    en: 'Fare Estimate',
    hi: 'किराया अनुमान',
    te: 'ఫేర్ ఎస్టిమేట్',
    mr: 'भाडे अंदाज',
    kn: 'ದರ ಅಂದಾಜು',
    ta: 'கட்டண மதிப்பீடு',
    bn: 'ভাড়ার অনুমান',
    gu: 'ભાડાનો અંદાજ',
  },
  total_fare: {
    en: 'Total Fare',
    hi: 'कुल किराया',
    te: 'మొత్తం ఫేర్',
    mr: 'एकूण भाडे',
    kn: 'ಒಟ್ಟು ದರ',
    ta: 'மொத்த கட்டணம்',
    bn: 'মোট ভাড়া',
    gu: 'કુલ ભાડું',
  },
  distance: {
    en: 'Distance',
    hi: 'दूरी',
    te: 'దూరం',
    mr: 'अंतर',
    kn: 'ದೂರ',
    ta: 'தூரம்',
    bn: 'দূরত্ব',
    gu: 'અંતર',
  },
  estimated_time: {
    en: 'Estimated Time',
    hi: 'अनुमानित समय',
    te: 'అంచనా సమయం',
    mr: 'अंदाजे वेळ',
    kn: 'ಅಂದಾಜು ಸಮಯ',
    ta: 'மதிப்பிட்ட நேரம்',
    bn: 'আনুমানিক সময়',
    gu: 'અંદાજિત સમય',
  },
  payment_mode: {
    en: 'Payment Mode',
    hi: 'भुगतान का तरीका',
    te: 'పేమెంట్ మోడ్',
    mr: 'पेमेंट मोड',
    kn: 'ಪಾವತಿ ವಿಧಾನ',
    ta: 'பேமென்ட் மோட்',
    bn: 'পেমেন্ট মোড',
    gu: 'પેમેન્ટ મોડ',
  },
  cash: {
    en: 'Cash',
    hi: 'कैश',
    te: 'క్యాష్',
    mr: 'कॅश',
    kn: 'ಕ್ಯಾಶ್',
    ta: 'கேஷ்',
    bn: 'ক্যাশ',
    gu: 'કેશ',
  },
  online: {
    en: 'Online',
    hi: 'ऑनलाइन',
    te: 'ఆన్‌లైన్',
    mr: 'ऑनलाइन',
    kn: 'ಆನ್‌ಲೈನ್',
    ta: 'ஆன்லைன்',
    bn: 'অনলাইন',
    gu: 'ઓનલાઇન',
  },

  // Ride Status
  finding_driver: {
    en: 'Finding Driver',
    hi: 'ड्राइवर ढूंढ रहे हैं',
    te: 'డ్రైవర్ కనుగొంటున్నాము',
    mr: 'ड्रायव्हर शोधत आहोत',
    kn: 'ಡ್ರೈವರ್ ಹುಡುಕುತ್ತಿದ್ದೇವೆ',
    ta: 'டிரைவர் தேடுகிறோம்',
    bn: 'ড্রাইভার খুঁজছি',
    gu: 'ડ્રાઇવર શોધી રહ્યા છીએ',
  },
  driver_assigned: {
    en: 'Driver Assigned',
    hi: 'ड्राइवर असाइन हो गया',
    te: 'డ్రైవర్ అసైన్ అయ్యారు',
    mr: 'ड्रायव्हर असाइन झाला',
    kn: 'ಡ್ರೈವರ್ ನಿಯೋಜಿಸಲಾಗಿದೆ',
    ta: 'டிரைவர் அசைன் ஆனார்',
    bn: 'ড্রাইভার অ্যাসাইন হয়েছে',
    gu: 'ડ્રાઇવર અસાઇન થયા',
  },
  driver_arriving: {
    en: 'Driver is arriving',
    hi: 'ड्राइवर आ रहा है',
    te: 'డ్రైవర్ వస్తున్నారు',
    mr: 'ड्रायव्हर येत आहे',
    kn: 'ಡ್ರೈವರ್ ಬರುತ್ತಿದ್ದಾರೆ',
    ta: 'டிரைவர் வருகிறார்',
    bn: 'ড্রাইভার আসছে',
    gu: 'ડ્રાઇવર આવી રહ્યા છે',
  },
  ride_started: {
    en: 'Ride Started',
    hi: 'राइड शुरू हो गई',
    te: 'రైడ్ ప్రారంభమైంది',
    mr: 'राइड सुरू झाली',
    kn: 'ರೈಡ್ ಪ್ರಾರಂಭವಾಯಿತು',
    ta: 'ரைடு தொடங்கியது',
    bn: 'রাইড শুরু হয়েছে',
    gu: 'રાઇડ શરૂ થઈ',
  },
  ride_completed: {
    en: 'Ride Completed',
    hi: 'राइड पूरी हो गई',
    te: 'రైడ్ పూర్తయింది',
    mr: 'राइड पूर्ण झाली',
    kn: 'ರೈಡ್ ಮುಗಿಯಿತು',
    ta: 'ரைடு முடிந்தது',
    bn: 'রাইড সম্পন্ন হয়েছে',
    gu: 'રાઇડ પૂર્ણ થઈ',
  },

  // Time Units
  hours: {
    en: 'Hours',
    hi: 'घंटे',
    te: 'గంటలు',
    mr: 'तास',
    kn: 'ಗಂಟೆಗಳು',
    ta: 'மணிநேரம்',
    bn: 'ঘণ্টা',
    gu: 'કલાકો',
  },
  number_of_hours: {
    en: 'Number of Hours',
    hi: 'घंटों की संख्या',
    te: 'గంటల సంఖ్య',
    mr: 'तासांची संख्या',
    kn: 'ಗಂಟೆಗಳ ಸಂಖ್ಯೆ',
    ta: 'மணிநேர எண்ணிக்கை',
    bn: 'ঘণ্টার সংখ্যা',
    gu: 'કલાકોની સંખ્યા',
  },
  number_of_days: {
    en: 'Number of Days',
    hi: 'दिनों की संख्या',
    te: 'రోజుల సంఖ్య',
    mr: 'दिवसांची संख्या',
    kn: 'ದಿನಗಳ ಸಂಖ್ಯೆ',
    ta: 'நாட்களின் எண்ணிக்கை',
    bn: 'দিনের সংখ্যা',
    gu: 'દિવસોની સંખ્યા',
  },
  package_weight_kg: {
    en: 'Package Weight (kg)',
    hi: 'पैकेज का वजन (किलो)',
    te: 'ప్యాకేజ్ బరువు (కిలో)',
    mr: 'पॅकेज वजन (किलो)',
    kn: 'ಪ್ಯಾಕೇಜ್ ತೂಕ (ಕಿಲೋ)',
    ta: 'பேக்கேஜ் எடை (கிலோ)',
    bn: 'প্যাকেজ ওজন (কিলো)',
    gu: 'પેકેજ વજન (કિલો)',
  },
  wait_time: {
    en: 'Wait Time',
    hi: 'इंतज़ार का समय',
    te: 'వేచి ఉండే సమయం',
    mr: 'प्रतीक्षा वेळ',
    kn: 'ಕಾಯುವ ಸಮಯ',
    ta: 'காத்திருப்பு நேரம்',
    bn: 'অপেক্ষার সময়',
    gu: 'રાહ જોવાનો સમય',
  },
  drop_optional: {
    en: 'Drop-off location is optional',
    hi: 'ड्रॉप लोकेशन वैकल्पिक है',
    te: 'డ్రాప్ లొకేషన్ ఐచ్ఛికం',
    mr: 'ड्रॉप लोकेशन पर्यायी आहे',
    kn: 'ಡ್ರಾಪ್ ಲೊಕೇಶನ್ ಐಚ್ಛಿಕ',
    ta: 'டிராப் லொகேஷன் விருப்பமானது',
    bn: 'ড্রপ লোকেশন ঐচ্ছিক',
    gu: 'ડ્રોપ લોકેશન વૈકલ્પિક છે',
  },
  extra_km: {
    en: 'Extra km',
    hi: 'अतिरिक्त किमी',
    te: 'అదనపు కిమీ',
    mr: 'अतिरिक्त किमी',
    kn: 'ಹೆಚ್ಚುವರಿ ಕಿಮೀ',
    ta: 'கூடுதல் கிமீ',
    bn: 'অতিরিক্ত কিমি',
    gu: 'વધારાના કિમી',
  },
  includes: {
    en: 'Includes',
    hi: 'शामिल है',
    te: 'కలిగి ఉంది',
    mr: 'समाविष्ट',
    kn: 'ಒಳಗೊಂಡಿದೆ',
    ta: 'உள்ளடக்கம்',
    bn: 'অন্তর্ভুক্ত',
    gu: 'સમાવિષ્ટ',
  },
  per_hour: {
    en: '/hr',
    hi: '/घंटा',
    te: '/గంట',
    mr: '/तास',
    kn: '/ಗಂಟೆ',
    ta: '/மணி',
    bn: '/ঘণ্টা',
    gu: '/કલાક',
  },
  per_day: {
    en: '/day',
    hi: '/दिन',
    te: '/రోజు',
    mr: '/दिवस',
    kn: '/ದಿನ',
    ta: '/நாள்',
    bn: '/দিন',
    gu: '/દિવસ',
  },
  days: {
    en: 'Days',
    hi: 'दिन',
    te: 'రోజులు',
    mr: 'दिवस',
    kn: 'ದಿನಗಳು',
    ta: 'நாட்கள்',
    bn: 'দিন',
    gu: 'દિવસો',
  },
  minutes: {
    en: 'Minutes',
    hi: 'मिनट',
    te: 'నిమిషాలు',
    mr: 'मिनिटे',
    kn: 'ನಿಮಿಷಗಳು',
    ta: 'நிமிடங்கள்',
    bn: 'মিনিট',
    gu: 'મિનિટ',
  },
  km: {
    en: 'km',
    hi: 'कि.मी.',
    te: 'కి.మీ.',
    mr: 'कि.मी.',
    kn: 'ಕಿ.ಮೀ.',
    ta: 'கி.மீ.',
    bn: 'কি.মি.',
    gu: 'કિ.મી.',
  },

  // Package Delivery
  send_package: {
    en: 'Send Package',
    hi: 'पैकेज भेजें',
    te: 'ప్యాకేజ్ పంపండి',
    mr: 'पॅकेज पाठवा',
    kn: 'ಪ್ಯಾಕೇಜ್ ಕಳುಹಿಸಿ',
    ta: 'பேக்கேஜ் அனுப்புங்கள்',
    bn: 'প্যাকেজ পাঠান',
    gu: 'પેકેજ મોકલો',
  },
  package_weight: {
    en: 'Package Weight',
    hi: 'पैकेज का वजन',
    te: 'ప్యాకేజ్ బరువు',
    mr: 'पॅकेज वजन',
    kn: 'ಪ್ಯಾಕೇಜ್ ತೂಕ',
    ta: 'பேக்கேஜ் எடை',
    bn: 'প্যাকেজ ওজন',
    gu: 'પેકેજ વજન',
  },
  recipient_name: {
    en: 'Recipient Name',
    hi: 'प्राप्तकर्ता का नाम',
    te: 'గ్రహీత పేరు',
    mr: 'प्राप्तकर्त्याचे नाव',
    kn: 'ಸ್ವೀಕರಿಸುವವರ ಹೆಸರು',
    ta: 'பெறுநர் பெயர்',
    bn: 'প্রাপকের নাম',
    gu: 'પ્રાપ્તકર્તાનું નામ',
  },
  recipient_phone: {
    en: 'Recipient Phone',
    hi: 'प्राप्तकर्ता का फोन',
    te: 'గ్రహీత ఫోన్',
    mr: 'प्राप्तकर्त्याचा फोन',
    kn: 'ಸ್ವೀಕರಿಸುವವರ ಫೋನ್',
    ta: 'பெறுநர் போன்',
    bn: 'প্রাপকের ফোন',
    gu: 'પ્રાપ્તકર્તાનો ફોન',
  },
  track_package: {
    en: 'Track Package',
    hi: 'पैकेज ट्रैक करें',
    te: 'ప్యాకేజ్ ట్రాక్ చేయండి',
    mr: 'पॅकेज ट्रॅक करा',
    kn: 'ಪ್ಯಾಕೇಜ್ ಟ್ರ್ಯಾಕ್ ಮಾಡಿ',
    ta: 'பேக்கேஜ் டிராக் செய்யுங்கள்',
    bn: 'প্যাকেজ ট্র্যাক করুন',
    gu: 'પેકેજ ટ્રેક કરો',
  },

  // Waiting Time
  estimated_wait_time: {
    en: 'Estimated Wait Time',
    hi: 'अनुमानित प्रतीक्षा समय',
    te: 'అంచనా వేచి ఉండే సమయం',
    mr: 'अंदाजे प्रतीक्षा वेळ',
    kn: 'ಅಂದಾಜು ಕಾಯುವ ಸಮಯ',
    ta: 'மதிப்பிட்ட காத்திருப்பு நேரம்',
    bn: 'আনুমানিক অপেক্ষার সময়',
    gu: 'અંદાજિત રાહ જોવાનો સમય',
  },
  waiting_charges: {
    en: 'Waiting Charges',
    hi: 'प्रतीक्षा शुल्क',
    te: 'వేచి ఉండే ఛార్జీలు',
    mr: 'प्रतीक्षा शुल्क',
    kn: 'ಕಾಯುವ ಶುಲ್ಕ',
    ta: 'காத்திருப்பு கட்டணம்',
    bn: 'অপেক্ষার চার্জ',
    gu: 'રાહ જોવાના ચાર્જ',
  },

  // Misc
  hello: {
    en: 'Hello',
    hi: 'नमस्ते',
    te: 'హలో',
    mr: 'नमस्कार',
    kn: 'ನಮಸ್ಕಾರ',
    ta: 'வணக்கம்',
    bn: 'নমস্কার',
    gu: 'નમસ્તે',
  },
  welcome: {
    en: 'Welcome',
    hi: 'स्वागत है',
    te: 'స్వాగతం',
    mr: 'स्वागत आहे',
    kn: 'ಸ್ವಾಗತ',
    ta: 'வரவேற்கிறோம்',
    bn: 'স্বাগতম',
    gu: 'સ્વાગત છે',
  },
  otp: {
    en: 'OTP',
    hi: 'ओटीपी',
    te: 'ఓటీపీ',
    mr: 'ओटीपी',
    kn: 'ಓಟಿಪಿ',
    ta: 'ஓடிபி',
    bn: 'ওটিপি',
    gu: 'ઓટીપી',
  },
  verify: {
    en: 'Verify',
    hi: 'वेरिफाई करें',
    te: 'వెరిఫై చేయండి',
    mr: 'वेरिफाय करा',
    kn: 'ವೆರಿಫೈ ಮಾಡಿ',
    ta: 'வெரிஃபை செய்யுங்கள்',
    bn: 'ভেরিফাই করুন',
    gu: 'વેરિફાય કરો',
  },
  phone_number: {
    en: 'Phone Number',
    hi: 'फोन नंबर',
    te: 'ఫోన్ నంబర్',
    mr: 'फोन नंबर',
    kn: 'ಫೋನ್ ನಂಬರ್',
    ta: 'போன் நம்பர்',
    bn: 'ফোন নম্বর',
    gu: 'ફોન નંબર',
  },
  select_language: {
    en: 'Select Language',
    hi: 'भाषा चुनें',
    te: 'భాష ఎంచుకోండి',
    mr: 'भाषा निवडा',
    kn: 'ಭಾಷೆ ಆಯ್ಕೆಮಾಡಿ',
    ta: 'மொழியைத் தேர்ந்தெடுக்கவும்',
    bn: 'ভাষা নির্বাচন করুন',
    gu: 'ભાષા પસંદ કરો',
  },
  per_hour: {
    en: 'per hour',
    hi: 'प्रति घंटा',
    te: 'గంటకు',
    mr: 'प्रति तास',
    kn: 'ಪ್ರತಿ ಗಂಟೆ',
    ta: 'ஒரு மணி நேரத்திற்கு',
    bn: 'প্রতি ঘণ্টা',
    gu: 'પ્રતિ કલાક',
  },
  per_day: {
    en: 'per day',
    hi: 'प्रति दिन',
    te: 'రోజుకు',
    mr: 'प्रति दिवस',
    kn: 'ಪ್ರತಿ ದಿನ',
    ta: 'ஒரு நாளைக்கு',
    bn: 'প্রতি দিন',
    gu: 'પ્રતિ દિવસ',
  },
  includes: {
    en: 'Includes',
    hi: 'शामिल है',
    te: 'కలిగి ఉంది',
    mr: 'समाविष्ट आहे',
    kn: 'ಒಳಗೊಂಡಿದೆ',
    ta: 'உள்ளடக்கியது',
    bn: 'অন্তর্ভুক্ত',
    gu: 'સમાવેશ થાય છે',
  },
  extra_km_charge: {
    en: 'Extra km charge',
    hi: 'अतिरिक्त कि.मी. शुल्क',
    te: 'అదనపు కి.మీ. ఛార్జ్',
    mr: 'अतिरिक्त कि.मी. शुल्क',
    kn: 'ಹೆಚ್ಚುವರಿ ಕಿ.ಮೀ. ಶುಲ್ಕ',
    ta: 'கூடுதல் கி.மீ. கட்டணம்',
    bn: 'অতিরিক্ত কি.মি. চার্জ',
    gu: 'વધારાની કિ.મી. ચાર્જ',
  },
  number_of_hours: {
    en: 'Number of Hours',
    hi: 'घंटों की संख्या',
    te: 'గంటల సంఖ్య',
    mr: 'तासांची संख्या',
    kn: 'ಗಂಟೆಗಳ ಸಂಖ್ಯೆ',
    ta: 'மணிநேரங்களின் எண்ணிக்கை',
    bn: 'ঘণ্টার সংখ্যা',
    gu: 'કલાકોની સંખ્યા',
  },
  number_of_days: {
    en: 'Number of Days',
    hi: 'दिनों की संख्या',
    te: 'రోజుల సంఖ్య',
    mr: 'दिवसांची संख्या',
    kn: 'ದಿನಗಳ ಸಂಖ್ಯೆ',
    ta: 'நாட்களின் எண்ணிக்கை',
    bn: 'দিনের সংখ্যা',
    gu: 'દિવસોની સંખ્યા',
  },

  // Rider App Specific
  earnings: {
    en: 'Earnings',
    hi: 'कमाई',
    te: 'ఆదాయం',
    mr: 'कमाई',
    kn: 'ಗಳಿಕೆ',
    ta: 'வருமானம்',
    bn: 'আয়',
    gu: 'કમાણી',
  },
  total_rides: {
    en: 'Total Rides',
    hi: 'कुल राइड्स',
    te: 'మొత్తం రైడ్స్',
    mr: 'एकूण राइड्स',
    kn: 'ಒಟ್ಟು ರೈಡ್ಸ್',
    ta: 'மொத்த ரைட்ஸ்',
    bn: 'মোট রাইডস',
    gu: 'કુલ રાઇડ્સ',
  },
  commission: {
    en: 'Commission',
    hi: 'कमीशन',
    te: 'కమీషన్',
    mr: 'कमिशन',
    kn: 'ಕಮಿಷನ್',
    ta: 'கமிஷன்',
    bn: 'কমিশন',
    gu: 'કમિશન',
  },
  tips: {
    en: 'Tips',
    hi: 'टिप्स',
    te: 'టిప్స్',
    mr: 'टिप्स',
    kn: 'ಟಿಪ್ಸ್',
    ta: 'டிப்ஸ்',
    bn: 'টিপস',
    gu: 'ટિપ્સ',
  },
  go_online: {
    en: 'Go Online',
    hi: 'ऑनलाइन जाएं',
    te: 'ఆన్‌లైన్ కి వెళ్ళండి',
    mr: 'ऑनलाइन व्हा',
    kn: 'ಆನ್‌ಲೈನ್ ಹೋಗಿ',
    ta: 'ஆன்லைன் செல்லுங்கள்',
    bn: 'অনলাইন যান',
    gu: 'ઓનલાઇન જાઓ',
  },
  go_offline: {
    en: 'Go Offline',
    hi: 'ऑफलाइन जाएं',
    te: 'ఆఫ్‌లైన్ కి వెళ్ళండి',
    mr: 'ऑफलाइन व्हा',
    kn: 'ಆಫ್‌ಲೈನ್ ಹೋಗಿ',
    ta: 'ஆஃப்லைன் செல்லுங்கள்',
    bn: 'অফলাইন যান',
    gu: 'ઓફલાઇન જાઓ',
  },
  accept_ride: {
    en: 'Accept Ride',
    hi: 'राइड स्वीकार करें',
    te: 'రైడ్ అంగీకరించండి',
    mr: 'राइड स्वीकारा',
    kn: 'ರೈಡ್ ಸ್ವೀಕರಿಸಿ',
    ta: 'ரைடு ஏற்றுக்கொள்ளுங்கள்',
    bn: 'রাইড গ্রহণ করুন',
    gu: 'રાઇડ સ્વીકારો',
  },
  start_ride: {
    en: 'Start Ride',
    hi: 'राइड शुरू करें',
    te: 'రైడ్ ప్రారంభించండి',
    mr: 'राइड सुरू करा',
    kn: 'ರೈಡ್ ಪ್ರಾರಂಭಿಸಿ',
    ta: 'ரைடு தொடங்குங்கள்',
    bn: 'রাইড শুরু করুন',
    gu: 'રાઇડ શરૂ કરો',
  },
  complete_ride: {
    en: 'Complete Ride',
    hi: 'राइड पूरी करें',
    te: 'రైడ్ పూర్తి చేయండి',
    mr: 'राइड पूर्ण करा',
    kn: 'ರೈಡ್ ಪೂರ್ಣಗೊಳಿಸಿ',
    ta: 'ரைடு முடியுங்கள்',
    bn: 'রাইড সম্পন্ন করুন',
    gu: 'રાઇડ પૂર્ણ કરો',
  },
  documents: {
    en: 'Documents',
    hi: 'दस्तावेज़',
    te: 'డాక్యుమెంట్స్',
    mr: 'दस्तऐवज',
    kn: 'ಡಾಕ್ಯುಮೆಂಟ್ಸ್',
    ta: 'ஆவணங்கள்',
    bn: 'ডকুমেন্টস',
    gu: 'દસ્તાવેજો',
  },
  vehicle_details: {
    en: 'Vehicle Details',
    hi: 'वाहन विवरण',
    te: 'వాహన వివరాలు',
    mr: 'वाहन तपशील',
    kn: 'ವಾಹನ ವಿವರಗಳು',
    ta: 'வாகன விவரங்கள்',
    bn: 'গাড়ির বিবরণ',
    gu: 'વાહન વિગતો',
  },
  available_rides: {
    en: 'Available Rides',
    hi: 'उपलब्ध राइड्स',
    te: 'అందుబాటులో ఉన్న రైడ్స్',
    mr: 'उपलब्ध राइड्स',
    kn: 'ಲಭ್ಯವಿರುವ ರೈಡ್ಸ್',
    ta: 'கிடைக்கும் ரைட்ஸ்',
    bn: 'উপলব্ধ রাইডস',
    gu: 'ઉપલબ્ધ રાઇડ્સ',
  },
  todays_earnings: {
    en: "Today's Earnings",
    hi: 'आज की कमाई',
    te: 'ఈ రోజు ఆదాయం',
    mr: 'आजची कमाई',
    kn: 'ಇಂದಿನ ಗಳಿಕೆ',
    ta: 'இன்றைய வருமானம்',
    bn: 'আজকের আয়',
    gu: 'આજની કમાણી',
  },
  pay_commission: {
    en: 'Pay Commission',
    hi: 'कमीशन भुगतान करें',
    te: 'కమీషన్ చెల్లించండి',
    mr: 'कमिशन भरा',
    kn: 'ಕಮಿಷನ್ ಪಾವತಿಸಿ',
    ta: 'கமிஷன் செலுத்துங்கள்',
    bn: 'কমিশন দিন',
    gu: 'કમિશન ચૂકવો',
  },
  save_changes: {
    en: 'Save Changes',
    hi: 'बदलाव सहेजें',
    te: 'మార్పులు సేవ్ చేయండి',
    mr: 'बदल जतन करा',
    kn: 'ಬದಲಾವಣೆಗಳನ್ನು ಉಳಿಸಿ',
    ta: 'மாற்றங்களை சேமிக்கவும்',
    bn: 'পরিবর্তন সংরক্ষণ করুন',
    gu: 'ફેરફારો સાચવો',
  },
  upload: {
    en: 'Upload',
    hi: 'अपलोड',
    te: 'అప్‌లోడ్',
    mr: 'अपलोड',
    kn: 'ಅಪ್‌ಲೋಡ್',
    ta: 'அப்லோட்',
    bn: 'আপলোড',
    gu: 'અપલોડ',
  },
  approved: {
    en: 'Approved',
    hi: 'स्वीकृत',
    te: 'ఆమోదించబడింది',
    mr: 'मंजूर',
    kn: 'ಅನುಮೋದಿಸಲಾಗಿದೆ',
    ta: 'அங்கீகரிக்கப்பட்டது',
    bn: 'অনুমোদিত',
    gu: 'મંજૂર',
  },
  pending: {
    en: 'Pending',
    hi: 'लंबित',
    te: 'పెండింగ్',
    mr: 'प्रलंबित',
    kn: 'ಬಾಕಿ',
    ta: 'நிலுவையில்',
    bn: 'বিচারাধীন',
    gu: 'બાકી',
  },
  rejected: {
    en: 'Rejected',
    hi: 'अस्वीकृत',
    te: 'తిరస్కరించబడింది',
    mr: 'नाकारले',
    kn: 'ತಿರಸ್ಕರಿಸಲಾಗಿದೆ',
    ta: 'நிராகரிக்கப்பட்டது',
    bn: 'প্রত্যাখ্যাত',
    gu: 'નકારેલ',
  },
  customer: {
    en: 'Customer',
    hi: 'ग्राहक',
    te: 'కస్టమర్',
    mr: 'ग्राहक',
    kn: 'ಗ್ರಾಹಕ',
    ta: 'வாடிக்கையாளர்',
    bn: 'গ্রাহক',
    gu: 'ગ્રાહક',
  },
  driver: {
    en: 'Driver',
    hi: 'ड्राइवर',
    te: 'డ్రైవర్',
    mr: 'चालक',
    kn: 'ಚಾಲಕ',
    ta: 'டிரைவர்',
    bn: 'চালক',
    gu: 'ડ્રાઇવર',
  },
  new_ride_request: {
    en: 'New Ride Request',
    hi: 'नई राइड रिक्वेस्ट',
    te: 'కొత్త రైడ్ రిక్వెస్ట్',
    mr: 'नवीन राइड विनंती',
    kn: 'ಹೊಸ ರೈಡ್ ವಿನಂತಿ',
    ta: 'புதிய ரைடு கோரிக்கை',
    bn: 'নতুন রাইড অনুরোধ',
    gu: 'નવી રાઇડ વિનંતી',
  },
  rate_customer: {
    en: 'Rate Customer',
    hi: 'ग्राहक को रेट करें',
    te: 'కస్టమర్‌ను రేట్ చేయండి',
    mr: 'ग्राहकाला रेट करा',
    kn: 'ಗ್ರಾಹಕನನ್ನು ರೇಟ್ ಮಾಡಿ',
    ta: 'வாடிக்கையாளரை மதிப்பிடுங்கள்',
    bn: 'গ্রাহককে রেট করুন',
    gu: 'ગ્રાહકને રેટ કરો',
  },
  no_rides_available: {
    en: 'No rides available',
    hi: 'कोई राइड उपलब्ध नहीं',
    te: 'రైడ్స్ అందుబాటులో లేవు',
    mr: 'कोणतीही राइड उपलब्ध नाही',
    kn: 'ರೈಡ್ಸ್ ಲಭ್ಯವಿಲ್ಲ',
    ta: 'ரைட்ஸ் கிடைக்கவில்லை',
    bn: 'কোন রাইড উপলব্ধ নেই',
    gu: 'કોઈ રાઇડ ઉપલબ્ધ નથી',
  },
  allow_other_subtypes: {
    en: 'Match with other available subtypes if my choice is unavailable',
    hi: 'अगर मेरी पसंद उपलब्ध नहीं है तो अन्य सबटाइप्स से मैच करें',
    te: 'నా ఎంపిక అందుబాటులో లేకపోతే ఇతర సబ్‌టైప్‌లతో మ్యాచ్ చేయండి',
    mr: 'माझी निवड उपलब्ध नसल्यास इतर सबटाइपशी जुळवा',
    kn: 'ನನ್ನ ಆಯ್ಕೆ ಲಭ್ಯವಿಲ್ಲದಿದ್ದರೆ ಇತರ ಸಬ್‌ಟೈಪ್‌ಗಳೊಂದಿಗೆ ಹೊಂದಿಸಿ',
    ta: 'என் தேர்வு கிடைக்கவில்லை என்றால் மற்ற சப்டைப்களுடன் பொருத்துங்கள்',
    bn: 'আমার পছন্দ উপলব্ধ না থাকলে অন্যান্য সাবটাইপের সাথে মিলিয়ে দিন',
    gu: 'જો મારી પસંદગી ઉપલબ્ધ ન હોય તો અન્ય સબટાઈપ સાથે મેચ કરો',
  },
  subtype: {
    en: 'Subtype',
    hi: 'सबटाइप',
    te: 'సబ్‌టైప్',
    mr: 'सबटाइप',
    kn: 'ಸಬ್‌ಟೈಪ್',
    ta: 'சப்டைப்',
    bn: 'সাবটাইপ',
    gu: 'સબટાઈપ',
  },
  
  // New Landing Page Keys
  get_started: {
    en: 'Get Started',
    hi: 'गेट स्टार्टेड',
    te: 'గెట్ స్టార్టెడ్',
    mr: 'गेट स्टार्टेड',
    kn: 'ಗೆಟ್ ಸ್ಟಾರ್ಟೆಡ್',
    ta: 'கெட் ஸ்டார்ட்டட்',
    bn: 'গেট স্টার্টেড',
    gu: 'ગેટ સ્ટાર્ટેડ',
  },
  join_as_rider: {
    en: 'Join as a Rider',
    hi: 'राइडर के रूप में जुड़ें',
    te: 'రైడర్‌గా జాయిన్ అవ్వండి',
    mr: 'राइडर म्हणून जोडा',
    kn: 'ರೈಡರ್ ಆಗಿ ಸೇರಿ',
    ta: 'ரைடராக சேருங்கள்',
    bn: 'রাইডার হিসাবে যোগ দিন',
    gu: 'રાઇડર તરીકે જોડાઓ',
  },
  earn_with_us: {
    en: 'Earn with us',
    hi: 'हमारे साथ कमाएं',
    te: 'మాతో సంపాదించండి',
    mr: 'आमच्यासोबत कमवा',
    kn: 'ನಮ್ಮೊಂದಿಗೆ ಗಳಿಸಿ',
    ta: 'எங்களுடன் சம்பாதியுங்கள்',
    bn: 'আমাদের সাথে আয় করুন',
    gu: 'અમારી સાથે કમાઓ',
  },
  book_a_ride_now: {
    en: 'Book a Ride Now',
    hi: 'अभी राइड बुक करें',
    te: 'ఇప్పుడే రైడ్ బుక్ చేయండి',
    mr: 'आता राइड बुक करा',
    kn: 'ಈಗ ರೈಡ್ ಬುಕ್ ಮಾಡಿ',
    ta: 'இப்போதே ரைடு புக் செய்யுங்கள்',
    bn: 'এখনই রাইড বুক করুন',
    gu: 'હવે રાઇડ બુક કરો',
  },
  pick_up_location: {
    en: 'Pick Up Location',
    hi: 'पिक अप लोकेशन',
    te: 'పిక్ అప్ లొకేషన్',
    mr: 'पिक अप लोकेशन',
    kn: 'ಪಿಕ್ ಅಪ್ ಲೊಕೇಶನ್',
    ta: 'பிக் அப் லொகேஷன்',
    bn: 'পিক আপ লোকেশন',
    gu: 'પિક અપ લોકેશન',
  },
  ready_to_ride: {
    en: 'Ready to ride?',
    hi: 'राइड के लिए तैयार?',
    te: 'రైడ్ చేయడానికి సిద్ధమా?',
    mr: 'राइडसाठी तयार?',
    kn: 'ರೈಡ್ ಮಾಡಲು ಸಿದ್ಧವಾ?',
    ta: 'ரைடுக்கு தயாரா?',
    bn: 'রাইড করতে প্রস্তুত?',
    gu: 'રાઇડ માટે તૈયાર છો?',
  },
  your_ride_anytime: {
    en: 'Your Ride, Anytime',
    hi: 'आपकी राइड, कभी भी',
    te: 'మీ రైడ్, ఎప్పుడైనా',
    mr: 'तुमची राइड, कधीही',
    kn: 'ನಿಮ್ಮ ರೈಡ್, ಯಾವಾಗಲಾದರೂ',
    ta: 'உங்கள் ரைடு, எப்போதும்',
    bn: 'আপনার রাইড, যেকোনো সময়',
    gu: 'તમારી રાઇડ, ગમે ત્યારે',
  },
  login: {
    en: 'Login',
    hi: 'लॉगिन',
    te: 'లాగిన్',
    mr: 'लॉगिन',
    kn: 'ಲಾಗಿನ್',
    ta: 'லாகின்',
    bn: 'লগইন',
    gu: 'લોગિન',
  },
  welcome_back: {
    en: 'Welcome Back',
    hi: 'वापस स्वागत है',
    te: 'తిరిగి స్వాగతం',
    mr: 'परत स्वागत आहे',
    kn: 'ಮರಳಿ ಸ್ವಾಗತ',
    ta: 'மீண்டும் வரவேற்கிறோம்',
    bn: 'আবার স্বাগতম',
    gu: 'પાછા આવો સ્વાગત છે',
  },
  create_account: {
    en: 'Create Account',
    hi: 'अकाउंट बनाएं',
    te: 'అకౌంట్ క్రియేట్ చేయండి',
    mr: 'अकाउंट तयार करा',
    kn: 'ಖಾತೆ ರಚಿಸಿ',
    ta: 'அக்கவுண்ட் உருவாக்குங்கள்',
    bn: 'অ্যাকাউন্ট তৈরি করুন',
    gu: 'એકાઉન્ટ બનાવો',
  },
  
  // Customer Dashboard Keys
  where_to: {
    en: 'Where to?',
    hi: 'कहाँ जाना है?',
    te: 'ఎక్కడికి?',
    mr: 'कुठे जायचे?',
    kn: 'ಎಲ್ಲಿಗೆ?',
    ta: 'எங்கே?',
    bn: 'কোথায় যাবেন?',
    gu: 'ક્યાં જવું છે?',
  },
  open_map: {
    en: 'Open Map',
    hi: 'मैप खोलें',
    te: 'మ్యాప్ ఓపెన్ చేయండి',
    mr: 'मॅप उघडा',
    kn: 'ಮ್ಯಾಪ್ ತೆರೆಯಿರಿ',
    ta: 'மேப் திறக்கவும்',
    bn: 'ম্যাপ খুলুন',
    gu: 'મેપ ખોલો',
  },
  use_my_current_location: {
    en: 'Use My Current Location',
    hi: 'मेरी वर्तमान लोकेशन का उपयोग करें',
    te: 'నా ప్రస్తుత లొకేషన్ వాడండి',
    mr: 'माझे सध्याचे लोकेशन वापरा',
    kn: 'ನನ್ನ ಪ್ರಸ್ತುತ ಲೊಕೇಶನ್ ಬಳಸಿ',
    ta: 'என் தற்போதைய லொகேஷன் பயன்படுத்து',
    bn: 'আমার বর্তমান লোকেশন ব্যবহার করুন',
    gu: 'મારું વર્તમાન લોકેશન વાપરો',
  },
  select_pickup_location: {
    en: 'Select pickup location',
    hi: 'पिकअप लोकेशन चुनें',
    te: 'పికప్ లొకేషన్ ఎంచుకోండి',
    mr: 'पिकअप लोकेशन निवडा',
    kn: 'ಪಿಕಪ್ ಲೊಕೇಶನ್ ಆಯ್ಕೆಮಾಡಿ',
    ta: 'பிக்கப் லொகேஷன் தேர்ந்தெடுக்கவும்',
    bn: 'পিকআপ লোকেশন নির্বাচন করুন',
    gu: 'પિકઅપ લોકેશન પસંદ કરો',
  },
  select_drop_location_on_map: {
    en: 'Select drop location on map',
    hi: 'मैप पर ड्रॉप लोकेशन चुनें',
    te: 'మ్యాప్‌లో డ్రాప్ లొకేషన్ ఎంచుకోండి',
    mr: 'मॅपवर ड्रॉप लोकेशन निवडा',
    kn: 'ಮ್ಯಾಪ್‌ನಲ್ಲಿ ಡ್ರಾಪ್ ಲೊಕೇಶನ್ ಆಯ್ಕೆಮಾಡಿ',
    ta: 'மேப்பில் டிராப் லொகேஷன் தேர்ந்தெடுக்கவும்',
    bn: 'ম্যাপে ড্রপ লোকেশন নির্বাচন করুন',
    gu: 'મેપ પર ડ્રોપ લોકેશન પસંદ કરો',
  },
  i_will_tell_the_driver: {
    en: 'I will tell the driver',
    hi: 'मैं ड्राइवर को बताऊंगा',
    te: 'నేను డ్రైవర్‌కు చెప్తాను',
    mr: 'मी ड्रायव्हरला सांगेन',
    kn: 'ನಾನು ಡ್ರೈವರ್‌ಗೆ ಹೇಳುತ್ತೇನೆ',
    ta: 'நான் டிரைவருக்கு சொல்வேன்',
    bn: 'আমি ড্রাইভারকে বলব',
    gu: 'હું ડ્રાઇવરને કહીશ',
  },
  saved_locations: {
    en: 'Saved Locations',
    hi: 'सेव्ड लोकेशन्स',
    te: 'సేవ్ చేసిన లొకేషన్లు',
    mr: 'सेव्ड लोकेशन्स',
    kn: 'ಸೇವ್ ಮಾಡಿದ ಲೊಕೇಶನ್‌ಗಳು',
    ta: 'சேவ் செய்த லொகேஷன்கள்',
    bn: 'সেভ করা লোকেশন',
    gu: 'સેવ કરેલ લોકેશન્સ',
  },
  favorite_riders: {
    en: 'Favorite Riders',
    hi: 'फेवरिट राइडर्स',
    te: 'ఫేవరెట్ రైడర్లు',
    mr: 'फेवरिट राइडर्स',
    kn: 'ಫೇವರಿಟ್ ರೈಡರ್‌ಗಳು',
    ta: 'ஃபேவரிட் ரைடர்கள்',
    bn: 'ফেভারিট রাইডার্স',
    gu: 'ફેવરિટ રાઇડર્સ',
  },
  choose_vehicle: {
    en: 'Choose Vehicle',
    hi: 'वाहन चुनें',
    te: 'వాహనం ఎంచుకోండి',
    mr: 'वाहन निवडा',
    kn: 'ವಾಹನ ಆಯ್ಕೆಮಾಡಿ',
    ta: 'வாகனம் தேர்ந்தெடுக்கவும்',
    bn: 'গাড়ি নির্বাচন করুন',
    gu: 'વાહન પસંદ કરો',
  },
  add_new: {
    en: 'Add New',
    hi: 'नया जोड़ें',
    te: 'కొత్తది జోడించండి',
    mr: 'नवीन जोडा',
    kn: 'ಹೊಸದನ್ನು ಸೇರಿಸಿ',
    ta: 'புதியதை சேர்க்கவும்',
    bn: 'নতুন যোগ করুন',
    gu: 'નવું ઉમેરો',
  },
  manage: {
    en: 'Manage',
    hi: 'मैनेज करें',
    te: 'మేనేజ్ చేయండి',
    mr: 'व्यवस्थापित करा',
    kn: 'ನಿರ್ವಹಿಸಿ',
    ta: 'நிர்வகிக்கவும்',
    bn: 'ম্যানেজ করুন',
    gu: 'મેનેજ કરો',
  },
  
  // Rider App Keys
  subscription: {
    en: 'Subscription',
    hi: 'सब्सक्रिप्शन',
    te: 'సబ్‌స్క్రిప్షన్',
    mr: 'सबस्क्रिप्शन',
    kn: 'ಸಬ್‌ಸ್ಕ್ರಿಪ್ಷನ್',
    ta: 'சப்ஸ்கிரிப்ஷன்',
    bn: 'সাবস্ক্রিপশন',
    gu: 'સબ્સ્ક્રિપ્શન',
  },
  change_plan: {
    en: 'Change Plan',
    hi: 'प्लान बदलें',
    te: 'ప్లాన్ మార్చండి',
    mr: 'प्लॅन बदला',
    kn: 'ಪ್ಲಾನ್ ಬದಲಾಯಿಸಿ',
    ta: 'பிளான் மாற்றவும்',
    bn: 'প্ল্যান পরিবর্তন করুন',
    gu: 'પ્લાન બદલો',
  },
  current_plan: {
    en: 'Current Plan',
    hi: 'वर्तमान प्लान',
    te: 'ప్రస్తుత ప్లాన్',
    mr: 'सध्याचा प्लॅन',
    kn: 'ಪ್ರಸ್ತುತ ಪ್ಲಾನ್',
    ta: 'தற்போதைய பிளான்',
    bn: 'বর্তমান প্ল্যান',
    gu: 'વર્તમાન પ્લાન',
  },
  renew: {
    en: 'Renew',
    hi: 'रिन्यू करें',
    te: 'రెన్యూ చేయండి',
    mr: 'रिन्यू करा',
    kn: 'ರಿನ್ಯೂ ಮಾಡಿ',
    ta: 'ரெனியூ செய்யவும்',
    bn: 'রিনিউ করুন',
    gu: 'રિન્યૂ કરો',
  },
  expires_on: {
    en: 'Expires on',
    hi: 'समाप्ति तिथि',
    te: 'గడువు తేదీ',
    mr: 'समाप्ती तारीख',
    kn: 'ಅವಧಿ ಮುಗಿಯುವ ದಿನಾಂಕ',
    ta: 'காலாவதி தேதி',
    bn: 'মেয়াদ শেষ',
    gu: 'સમાપ્તિ તારીખ',
  },
  active: {
    en: 'Active',
    hi: 'एक्टिव',
    te: 'యాక్టివ్',
    mr: 'ॲक्टिव्ह',
    kn: 'ಆಕ್ಟಿವ್',
    ta: 'ஆக்டிவ்',
    bn: 'অ্যাক্টিভ',
    gu: 'એક્ટિવ',
  },
  expired: {
    en: 'Expired',
    hi: 'एक्सपायर्ड',
    te: 'ఎక్స్‌పైర్డ్',
    mr: 'एक्सपायर्ड',
    kn: 'ಎಕ್ಸ್‌ಪೈರ್ಡ್',
    ta: 'எக்ஸ்பைர்ட்',
    bn: 'এক্সপায়ার্ড',
    gu: 'એક્સપાયર્ડ',
  },
  daily_plan: {
    en: 'Daily Plan',
    hi: 'डेली प्लान',
    te: 'డైలీ ప్లాన్',
    mr: 'डेली प्लॅन',
    kn: 'ಡೈಲಿ ಪ್ಲಾನ್',
    ta: 'டெய்லி பிளான்',
    bn: 'ডেইলি প্ল্যান',
    gu: 'ડેઇલી પ્લાન',
  },
  weekly_plan: {
    en: 'Weekly Plan',
    hi: 'वीकली प्लान',
    te: 'వీక్లీ ప్లాన్',
    mr: 'वीकली प्लॅन',
    kn: 'ವೀಕ್ಲಿ ಪ್ಲಾನ್',
    ta: 'வீக்லி பிளான்',
    bn: 'উইকলি প্ল্যান',
    gu: 'વીકલી પ્લાન',
  },
  monthly_plan: {
    en: 'Monthly Plan',
    hi: 'मंथली प्लान',
    te: 'మంత్లీ ప్లాన్',
    mr: 'मंथली प्लॅन',
    kn: 'ಮಂತ್ಲಿ ಪ್ಲಾನ್',
    ta: 'மாந்த்லி பிளான்',
    bn: 'মান্থলি প্ল্যান',
    gu: 'મન્થલી પ્લાન',
  },
  pay_per_ride: {
    en: 'Pay Per Ride',
    hi: 'पे पर राइड',
    te: 'పే పర్ రైడ్',
    mr: 'पे पर राइड',
    kn: 'ಪೇ ಪರ್ ರೈಡ್',
    ta: 'பே பெர் ரைடு',
    bn: 'পে পার রাইড',
    gu: 'પે પર રાઇડ',
  },
  support: {
    en: 'Support',
    hi: 'सपोर्ट',
    te: 'సపోర్ట్',
    mr: 'सपोर्ट',
    kn: 'ಸಪೋರ್ಟ್',
    ta: 'சப்போர்ட்',
    bn: 'সাপোর্ট',
    gu: 'સપોર્ટ',
  },
  contact_admin: {
    en: 'Contact Admin',
    hi: 'एडमिन से संपर्क करें',
    te: 'అడ్మిన్‌ను సంప్రదించండి',
    mr: 'ॲडमिनशी संपर्क साधा',
    kn: 'ಅಡ್ಮಿನ್ ಅನ್ನು ಸಂಪರ್ಕಿಸಿ',
    ta: 'அட்மின் தொடர்பு கொள்ளவும்',
    bn: 'অ্যাডমিনের সাথে যোগাযোগ করুন',
    gu: 'એડમિનનો સંપર્ક કરો',
  },
  help: {
    en: 'Help',
    hi: 'हेल्प',
    te: 'హెల్ప్',
    mr: 'मदत',
    kn: 'ಸಹಾಯ',
    ta: 'உதவி',
    bn: 'সাহায্য',
    gu: 'મદদ',
  },
  getting_location: {
    en: 'Getting location...',
    hi: 'लोकेशन प्राप्त कर रहे हैं...',
    te: 'లొకేషన్ పొందుతోంది...',
    mr: 'लोकेशन मिळवत आहे...',
    kn: 'ಲೊಕೇಶನ್ ಪಡೆಯುತ್ತಿದೆ...',
    ta: 'லொகேஷன் பெறுகிறது...',
    bn: 'লোকেশন পাচ্ছে...',
    gu: 'લોકેશન મેળવી રહ્યા છીએ...',
  },
  manage_all: {
    en: 'Manage All',
    hi: 'सभी मैनेज करें',
    te: 'అన్నీ మేనేజ్ చేయండి',
    mr: 'सर्व व्यवस्थापित करा',
    kn: 'ಎಲ್ಲಾ ನಿರ್ವಹಿಸಿ',
    ta: 'அனைத்தையும் நிர்வகிக்கவும்',
    bn: 'সব ম্যানেজ করুন',
    gu: 'બધું મેનેજ કરો',
  },
  pickup: {
    en: 'Pickup',
    hi: 'पिकअप',
    te: 'పికప్',
    mr: 'पिकअप',
    kn: 'ಪಿಕಪ್',
    ta: 'பிக்கப்',
    bn: 'পিকআপ',
    gu: 'પિકઅપ',
  },
  drop_off: {
    en: 'Drop',
    hi: 'ड्रॉप',
    te: 'డ్రాప్',
    mr: 'ड्रॉप',
    kn: 'ಡ್ರಾಪ್',
    ta: 'டிராப்',
    bn: 'ড্রপ',
    gu: 'ડ્રોપ',
  },
  view_all_saved_locations: {
    en: 'View all saved locations',
    hi: 'सभी सेव्ड लोकेशन देखें',
    te: 'అన్ని సేవ్ చేసిన లొకేషన్లు చూడండి',
    mr: 'सर्व सेव्ड लोकेशन पहा',
    kn: 'ಎಲ್ಲಾ ಸೇವ್ ಮಾಡಿದ ಲೊಕೇಶನ್‌ಗಳನ್ನು ನೋಡಿ',
    ta: 'அனைத்து சேவ் செய்த லொகேஷன்களையும் பார்க்கவும்',
    bn: 'সব সেভ করা লোকেশন দেখুন',
    gu: 'બધા સેવ કરેલ લોકેશન જુઓ',
  },
  selected: {
    en: 'selected',
    hi: 'चयनित',
    te: 'ఎంపిక చేయబడింది',
    mr: 'निवडले',
    kn: 'ಆಯ್ಕೆ ಮಾಡಲಾಗಿದೆ',
    ta: 'தேர்ந்தெடுக்கப்பட்டது',
    bn: 'নির্বাচিত',
    gu: 'પસંદ કરેલ',
  },
  approx: {
    en: 'approx',
    hi: 'लगभग',
    te: 'సుమారు',
    mr: 'अंदाजे',
    kn: 'ಸರಿಸುಮಾರು',
    ta: 'தோராயமாக',
    bn: 'প্রায়',
    gu: 'આશરે',
  },
  more_services: {
    en: 'More Services',
    hi: 'और सेवाएं',
    te: 'మరిన్ని సేవలు',
    mr: 'अधिक सेवा',
    kn: 'ಹೆಚ್ಚಿನ ಸೇವೆಗಳು',
    ta: 'மேலும் சேவைகள்',
    bn: 'আরও সেবা',
    gu: 'વધુ સેવાઓ',
  },
  order_food_delivery: {
    en: 'Order food delivery',
    hi: 'खाना ऑर्डर करें',
    te: 'ఆహారం ఆర్డర్ చేయండి',
    mr: 'जेवण ऑर्डर करा',
    kn: 'ಆಹಾರ ಆರ್ಡರ್ ಮಾಡಿ',
    ta: 'உணவு ஆர்டர் செய்யுங்கள்',
    bn: 'খাবার অর্ডার করুন',
    gu: 'ખોરાક ઓર્ડર કરો',
  },
  rent_farming_tools: {
    en: 'Rent farming tools',
    hi: 'खेती के उपकरण किराए पर लें',
    te: 'వ్యవసాయ పరికరాలు అద్దెకు తీసుకోండి',
    mr: 'शेतीची साधने भाड्याने घ्या',
    kn: 'ಕೃಷಿ ಉಪಕರಣಗಳನ್ನು ಬಾಡಿಗೆಗೆ ಪಡೆಯಿರಿ',
    ta: 'விவசாய கருவிகளை வாடகைக்கு எடுங்கள்',
    bn: 'কৃষি সরঞ্জাম ভাড়া নিন',
    gu: 'ખેતીના સાધનો ભાડે લો',
  },
  coming_soon: {
    en: 'Coming Soon',
    hi: 'जल्द आ रहा है',
    te: 'త్వరలో వస్తోంది',
    mr: 'लवकरच येत आहे',
    kn: 'ಶೀಘ್ರದಲ್ಲೇ ಬರುತ್ತಿದೆ',
    ta: 'விரைவில் வருகிறது',
    bn: 'শীঘ্রই আসছে',
    gu: 'ટૂંક સમયમાં આવી રહ્યું છે',
  },
  select_approximate_distance: {
    en: 'Select approximate distance. You\'ll tell the driver your exact destination.',
    hi: 'लगभग दूरी चुनें। आप ड्राइवर को सही जगह बताएंगे।',
    te: 'సుమారు దూరం ఎంచుకోండి. మీరు డ్రైవర్‌కు ఖచ్చితమైన లొకేషన్ చెప్తారు.',
    mr: 'अंदाजे अंतर निवडा. तुम्ही ड्रायव्हरला नेमके ठिकाण सांगाल.',
    kn: 'ಸರಿಸುಮಾರು ದೂರ ಆಯ್ಕೆಮಾಡಿ. ನೀವು ಡ್ರೈವರ್‌ಗೆ ನಿಖರವಾದ ಸ್ಥಳ ಹೇಳುತ್ತೀರಿ.',
    ta: 'தோராயமான தூரத்தைத் தேர்ந்தெடுங்கள். நீங்கள் டிரைவருக்கு சரியான இடத்தைச் சொல்வீர்கள்.',
    bn: 'আনুমানিক দূরত্ব নির্বাচন করুন। আপনি ড্রাইভারকে সঠিক জায়গা বলবেন।',
    gu: 'અંદાજિત અંતર પસંદ કરો. તમે ડ્રાઇવરને સાચી જગ્યા કહેશો.',
  },
  select_approximate_distance_short: {
    en: 'Select approximate distance:',
    hi: 'लगभग दूरी चुनें:',
    te: 'సుమారు దూరం ఎంచుకోండి:',
    mr: 'अंदाजे अंतर निवडा:',
    kn: 'ಸರಿಸುಮಾರು ದೂರ ಆಯ್ಕೆಮಾಡಿ:',
    ta: 'தோராயமான தூரம் தேர்ந்தெடுக்கவும்:',
    bn: 'আনুমানিক দূরত্ব নির্বাচন করুন:',
    gu: 'અંદાજિત અંતર પસંદ કરો:',
  },
};

// Helper function to get translation
export const t = (key, lang = 'en') => {
  if (translations[key] && translations[key][lang]) {
    return translations[key][lang];
  }
  // Fallback to English
  if (translations[key] && translations[key]['en']) {
    return translations[key]['en'];
  }
  // If key not found, return the key itself
  return key;
};

export default translations;
